var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwiter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1236 2.59869C20.3369 2.94053 19.5045 3.16574 18.6527 3.26721C19.5478 2.74305 20.221 1.91032 20.546 0.925201C19.6997 1.42008 18.7753 1.76731 17.8125 1.95201C17.407 1.5271 16.9194 1.18907 16.3793 0.958472C15.8391 0.727872 15.2577 0.609518 14.6704 0.610603C12.2926 0.610603 10.3683 2.50693 10.3683 4.84457C10.3666 5.16973 10.4039 5.49392 10.4793 5.81021C8.77418 5.73028 7.10455 5.29531 5.5772 4.53314C4.04985 3.77097 2.69841 2.69838 1.60934 1.38399C1.22727 2.02809 1.02521 2.763 1.02427 3.5119C1.02427 4.98002 1.79023 6.27774 2.94682 7.03802C2.26158 7.02176 1.59037 6.84039 0.990193 6.50932V6.56175C0.990193 8.61538 2.4758 10.3238 4.44203 10.7127C4.07229 10.8113 3.69127 10.8612 3.30861 10.8613C3.03708 10.8617 2.76617 10.8354 2.49983 10.7826C3.04644 12.4648 4.63735 13.6883 6.52188 13.7232C4.99056 14.9034 3.11051 15.5412 1.1772 15.5365C0.834038 15.536 0.49119 15.5156 0.150391 15.4754C2.11714 16.7312 4.40334 17.3955 6.73685 17.3892C14.6612 17.3892 18.9905 10.9355 18.9905 5.33831C18.9905 5.1548 18.9856 4.97128 18.9769 4.79214C19.8172 4.19443 20.5441 3.45165 21.1236 2.59869Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwiter);
export default __webpack_public_path__ + "static/media/Twiter.5ec08c6cb8729dba1f7aa1a6bc90871f.svg";
export { ForwardRef as ReactComponent };